import { jsx, jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { cn } from "../../../lib/utils.js";
import { QuizImage } from "./quiz-image.js";
import { DesmosGraph } from "./desmos-graph.js";
import { formatText } from "../../../utils/quiz-parser.js";
import { motion } from "../../../node_modules/.pnpm/framer-motion@11.18.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/framer-motion/dist/es/render/components/motion/proxy.js";
import Lightbulb from "../../../node_modules/.pnpm/lucide-react@0.309.0_react@18.3.1/node_modules/lucide-react/dist/esm/icons/lightbulb.js";
function QuizSolveDescription({
  description: descProp,
  commentaryImages,
  vars,
  id = "solve-desc",
  className,
  actionVisible,
  actionLabel,
  onActionClick
}) {
  const { t } = useTranslation("quiz");
  const description = descProp ?? {
    text: void 0,
    image: null,
    imageMobile: null,
    desmos: null
  };
  const hasText = description.text && description.text.trim().length > 0;
  const hasImage = description.image || description.imageMobile;
  const hasDesmos = !!description.desmos;
  const imgs = commentaryImages ?? void 0;
  return /* @__PURE__ */ jsx(
    motion.div,
    {
      initial: { opacity: 0, height: 0 },
      animate: { opacity: 1, height: "auto" },
      className: cn(
        "p-4 bg-linear-to-r from-gray-50 rounded-2xl border border-gray-200 to-slate-50",
        className
      ),
      children: /* @__PURE__ */ jsxs("div", { className: "flex gap-3 items-start", children: [
        /* @__PURE__ */ jsx("div", { className: "flex justify-center items-center w-8 h-8 bg-gray-600 rounded-full shrink-0", children: /* @__PURE__ */ jsx(Lightbulb, { className: "w-4 h-4 text-white" }) }),
        /* @__PURE__ */ jsxs("div", { className: "flex-1 space-y-3", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex gap-2 justify-between items-center h-8", children: [
            /* @__PURE__ */ jsx("p", { className: "text-lg font-semibold text-gray-700", children: t("shared.explanation") }),
            actionVisible && actionLabel && onActionClick && /* @__PURE__ */ jsx(
              "button",
              {
                onClick: onActionClick,
                className: "px-2 h-7 text-sm text-blue-600 rounded-md border border-blue-300 transition-colors hover:bg-blue-100",
                children: actionLabel
              }
            )
          ] }),
          hasText && /* @__PURE__ */ jsx("div", { className: "text-xl leading-relaxed text-gray-600", children: formatText(description.text, id, imgs) }),
          hasImage && /* @__PURE__ */ jsx(
            QuizImage,
            {
              image: description.image ?? void 0,
              imageMobile: description.imageMobile ?? void 0,
              alt: t("shared.explanationImage"),
              className: "my-2"
            }
          ),
          hasDesmos && /* @__PURE__ */ jsx("div", { className: "flex justify-center my-2", children: /* @__PURE__ */ jsx(
            DesmosGraph,
            {
              state: description.desmos,
              vars,
              className: "rounded-xl"
            }
          ) })
        ] })
      ] })
    }
  );
}
export {
  QuizSolveDescription
};
//# sourceMappingURL=quiz-solve-description.js.map
